import { IconName, Toggle } from '@ets/design-system';
import { CSSProperties, forwardRef, MouseEventHandler } from 'react';

/**
 * Editor topbar menu component
 */
type ToolbarToggleButtonProps = {
  disabled?: boolean;
  toggleButtonClicked: MouseEventHandler<HTMLSpanElement>;
  isActive?: boolean;
  margin?: CSSProperties['margin'];
  icon: IconName;
  sidebar?: boolean;
  color?: string;
  testId: string;
};

const ToolbarToggleButton = forwardRef<HTMLSpanElement, ToolbarToggleButtonProps>(
  ({ disabled, toggleButtonClicked, isActive, margin, icon, sidebar, color, testId }, ref) => {
    const onClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      if (!disabled) {
        toggleButtonClicked(e);
      }
    };
    return (
      <Toggle
        size="m"
        variant="link"
        isToggled={isActive}
        onClick={onClick}
        disabled={disabled}
        style={{ margin: margin }}
        iconProps={{
          icon,
          custom: color
            ? {
                primaryColor: color,
                secondaryColor: color,
                secondaryOpacity: '1',
                primaryOpacity: '0.8',
              }
            : undefined,
        }}
        testId={`${testId}`}
      />
    );
  },
);

export default ToolbarToggleButton;
